import { QueryClient } from "@tanstack/react-query";

/**
 * The app's server-state cache.
 *
 * Deliberately identical to `apps/core/src/lib/queryClient.ts`. The two apps
 * had already diverged on the thing Query replaces (a survey found the
 * hand-rolled stale-response guard written about a dozen different ways across
 * both), so the migration is not worth doing if the replacement diverges too.
 *
 * The defaults are the behaviour the hand-rolled hooks already had.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        /* Every mount revalidates. Reopening a panel is expected to produce
           fresh data; the cache decides what to PAINT while that request is in
           flight, never whether to send it. */
        staleTime: 0,
        refetchOnMount: true,
        refetchOnWindowFocus: true,
        /* No automatic retries: the hand-rolled hooks surfaced the first
           failure straight to the operator, and these surfaces are built around
           an explicit retry affordance rather than a silent backoff. */
        retry: false,
      },
    },
  });
}
